import { render, staticRenderFns } from "./tabs-admin.form.vue?vue&type=template&id=0c3ec60e&"
import script from "./tabs-admin.form.vue?vue&type=script&lang=ts&"
export * from "./tabs-admin.form.vue?vue&type=script&lang=ts&"
import style0 from "./tabs-admin.form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports